module.exports = __webpack_public_path__ + "static/media/Icon_CheckMark.b4136483.svg";